// extracted by mini-css-extract-plugin
module.exports = {"popupWrap":"LangPopup_popupWrap__g9wdT","dark":"dark","radioWrap":"LangPopup_radioWrap__5qIS4","radioButton":"LangPopup_radioButton__dNVfo","label":"LangPopup_label__d50qu"};